/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Grid, PopperProps } from '@mui/material';
import TextField from 'components/text-field';
import useSearchParty from 'hooks/useSearchParty';
import React, { ComponentType, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewUserType } from 'types/new-user';

import CustomPartyOption from './custom-party-option';
import { autocompleteRootProps } from 'v2-utils/autocomplete';

type SearchContactProps = {
  getValue: (user: NewUserType | null) => void;
  handleContactCreation?: (kind: string, searchText?: string) => void;
  popperComponent?: ComponentType<PopperProps>;
  disabled?: boolean;
  prevText?: string;
  className?: string;
  initialValue?: string;
  clearTextOnSelect?: boolean;
};

const SearchContact: FC<SearchContactProps> = ({
  getValue,
  handleContactCreation,
  popperComponent,
  disabled,
  prevText,
  className,
  initialValue,
  clearTextOnSelect = false,
}) => {
  const [searchText, setSearchText] = useState<string>(prevText || initialValue || '');

  const [localvalue, setLocalValue] = useState<NewUserType | null>(null);
  const { t } = useTranslation();

  const { parties } = useSearchParty(searchText);
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          className={className}
          disabled={disabled}
          value={localvalue}
          freeSolo
          fullWidth
          options={parties}
          PopperComponent={popperComponent}
          filterOptions={(options) =>
            options.length >= 0
              ? [
                ...options,
                {
                  _id: 'add-new-contact',
                  username: '',
                  user_id: '',
                  name: '',
                  emails: [],
                  addresses: [],
                  phones: [],
                } as unknown as NewUserType,
              ]
              : []}
          getOptionLabel={(party) => (typeof party === "string" ? party : party.name)}
          onInputChange={(_, value, reason) => {
            if (reason === 'input') {
              setSearchText(value);
            }
          }}
          renderOption={({ key, ...props }, option) => (
            <li key={key} {...props}>
              <CustomPartyOption
                contact={option}
                handleContactCreation={(kind) => {
                  setSearchText('');
                  if (handleContactCreation) {
                    handleContactCreation(kind, searchText);
                  }
                }}
                t={t}
              />
            </li>
          )}
          onChange={(_, value) => {
            _.stopPropagation();
            if (value && typeof value === 'object') {
              setLocalValue(
                clearTextOnSelect
                  ? ({
                    name: '',
                  } as NewUserType)
                  : value
              );
              getValue(value);
            } else {
              setLocalValue(null);
              getValue(null);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={params.InputProps.ref}
              InputProps={autocompleteRootProps(params.inputProps)}
              label={initialValue !== '' ? initialValue : t('parties:contact')}
              placeholder={t('parties:type-as-3-characters')}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default SearchContact;
